<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  [formCtrl]="dateCtrl"
></kodit-dropdown>
